import { getHttpErrMsg } from "@/log";

export default async ({ commit, state }, investorId) => {
    let investorData = state.diOrders[investorId];
    if (investorData) {
        if (investorData.expire_at > Date.now()) {
            return investorData.data;
        }
    }
    try {
        const res = await window.app.$api.request(
            "get",
            `api/investors-dashboard/${investorId}/orders/`
        );
        commit("SET_DI_ORDERS", res.data);
        return res.data;
    } catch (e) {
        console.log("getDiOrders", e);
        window.app.$ui.error(
            getHttpErrMsg(e, "Erreur lors de la récupération des ordres de l'investisseur")
        );
    }
};
